export default __webpack_public_path__ + "static/media/biberon.865f89e3.png";